// src/assets/userAvatars.js
import anshuman from "./avatars/anshuman.jpg";
import vijay from "./avatars/vijay.jpg";
import shivam from "./avatars/shivam.png";
import bk from "./avatars/bk.jpg";
import jjk from "./avatars/JJayakrishnan.jpg";
import akash from "./avatars/akaash.jpg";
import defaultImg from "./avatars/default.jpg";

export default {
  "sraj03@atkearney.com": shivam,
  "asharm17@atkearney.com": anshuman,
  "vkasi01@atkearney.com": vijay,
  "bshukl01@atkearney.com": bk,
  "jjayak01@atkearney.com": jjk,
  "ashanm01@atkearney.com": akash,
  "default": defaultImg,
};
